import React, { lazy } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import ProtectedRoute from './protectedRoutes';

// Lazy load pages
const LandingPage = lazy(() => import('../pages/js/global/landing-page'));
const CompetitionPage = lazy(() => import('../pages/js/global/competition-page'));
const SelectionPage = lazy(() => import('../pages/js/global/selection-page'));
const RoomSelection = lazy(() => import('../pages/js/global/room-selection'));
const FamilyImage = lazy(() => import('../pages/js/global/family-image'));
const FinishSelection = lazy(() => import('../pages/js/global/finish-selection'));
const SizeSelection = lazy(() => import('../pages/js/global/size-selection'));
const OrderPage = lazy(() => import('../pages/js/global/order-page'));
const ThanksPage = lazy(() => import('../pages/js/global/thanks-page'));

const LoginPage = lazy(() => import('../pages/js/login/login-page'));
const QRlogin = lazy(() => import('../pages/js/login/qr-login-page'));
const SignUpPage = lazy(() => import('../pages/js/login/sign-up-page'));

const ColourSelection = lazy(() => import('../pages/js/explore/colour-selection'));
const DisplayExplore = lazy(() => import('../pages/js/explore/display-page'));

const MoodSelection = lazy(() => import('../pages/js/inspire/mood-selection'));
const LightSelection = lazy(() => import('../pages/js/inspire/light-selection'));
const ThemeSelection = lazy(() => import('../pages/js/inspire/theme-selection'));
const SpaceSelection = lazy(() => import('../pages/js/inspire/space-selection'));
const DisplayInspire = lazy(() => import('../pages/js/inspire/display-page'));

export const AppRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                {/* Login Routes */}
                <Route path="/" element={<LoginPage />} />
                <Route path="/qr-login-page" element={<QRlogin />} />
                <Route path="/sign-up-page" element={<SignUpPage />} />

                {/* Global Routes */}
                <Route path="/global-landing-page" element={<LandingPage />} />
                <Route path="/global-competition-page" element={<CompetitionPage />} />
                <Route path="/global-family-image" element={<ProtectedRoute><FamilyImage /></ProtectedRoute>} />
                <Route path="/global-selection-page" element={<ProtectedRoute><SelectionPage /></ProtectedRoute>} />
                <Route path="/global-room-selection" element={<ProtectedRoute><RoomSelection /></ProtectedRoute>} />
                <Route path="/global-finish-selection" element={<ProtectedRoute><FinishSelection /></ProtectedRoute>} />
                <Route path="/global-size-selection" element={<ProtectedRoute><SizeSelection /></ProtectedRoute>} />
                <Route path="/global-order-page" element={<ProtectedRoute><OrderPage /></ProtectedRoute>} />
                <Route path="/global-thanks-page" element={<ProtectedRoute><ThanksPage /></ProtectedRoute>} />
                
                {/* Explore Routes */}
                <Route path="/explore-colour-selection" element={<ProtectedRoute><ColourSelection /></ProtectedRoute>} />
                <Route path="/explore-display-page" element={<ProtectedRoute><DisplayExplore /></ProtectedRoute>} />
                
                {/* Inspire Routes */}
                <Route path="/inspire-mood-selection" element={<ProtectedRoute><MoodSelection /></ProtectedRoute>} />
                <Route path="/inspire-light-selection" element={<ProtectedRoute><LightSelection /></ProtectedRoute>} />
                <Route path="/inspire-vision-selection" element={<ProtectedRoute><ThemeSelection /></ProtectedRoute>} />
                <Route path="/inspire-space-selection" element={<ProtectedRoute><SpaceSelection /></ProtectedRoute>} />
                <Route path="/inspire-display-page" element={<ProtectedRoute><DisplayInspire /></ProtectedRoute>} />
            </Routes>
        </AnimatePresence>
    );
};